import React from "react";
import PropTypes from "prop-types";
import { currentUserShape } from "shapes";

import CancelButton from "components/CancelButton";
import Modal, { ModalBody, ModalFooter, ModalHeader } from "components/Modal";
import SubmitButton from "components/SubmitButton";
import Translate from "utils/translate";

const { t } = new Translate("UserConfirmModal");

const UserConfirmAgreement = ({ currentUser, isOpen, onAgree, onCancel }) => (
  <Modal isOpen={isOpen}>
    <ModalHeader isCloseable={false}>{t("agreement.title")}</ModalHeader>
    <ModalBody>{t("agreement.description", { user: currentUser.fname })}</ModalBody>
    <ModalBody>
      <small dangerouslySetInnerHTML={{ __html: t("agreement.terms_description") }} />
    </ModalBody>
    <ModalFooter>
      <CancelButton onClick={onCancel} />
      <SubmitButton onSubmit={onAgree} submitLabel={t("agreement.agree")} />
    </ModalFooter>
  </Modal>
);

UserConfirmAgreement.propTypes = {
  currentUser: PropTypes.shape(currentUserShape),
  isOpen: PropTypes.bool,
  onAgree: PropTypes.func.isRequired,
  onCancel: PropTypes.func.isRequired,
};

export default UserConfirmAgreement;
